import type { AccountCreditsDto } from '@primetime/shared/apiContracts';

const ACCOUNT_STATE_SYNC_EVENT = 'primetime:account-state-sync';

export type AccountStateSyncDetail = {
  updatedCredits?: AccountCreditsDto;
  refreshLibrary?: boolean;
};

export function dispatchAccountStateSync(detail: AccountStateSyncDetail) {
  window.dispatchEvent(new CustomEvent<AccountStateSyncDetail>(ACCOUNT_STATE_SYNC_EVENT, { detail }));
}

export function onAccountStateSync(handler: (detail: AccountStateSyncDetail) => void) {
  const listener = (event: Event) => {
    handler((event as CustomEvent<AccountStateSyncDetail>).detail);
  };

  window.addEventListener(ACCOUNT_STATE_SYNC_EVENT, listener);
  return () => window.removeEventListener(ACCOUNT_STATE_SYNC_EVENT, listener);
}
